import React from 'react';
import { features } from '../data/mockData';
import { Store, Users, MapPin, Clock } from 'lucide-react';

const iconMap = { Store, Users, MapPin, Clock };

const AboutSection = () => (
  <section id="about" className="py-20 bg-[#0a0a0a]">
    <div className="max-w-7xl mx-auto px-6">
      <h2 className="text-4xl md:text-5xl font-bold text-center mb-16">
        <span className="text-white">About </span>
        <span className="text-[#c8ff00]">Stayfly Smokers</span>
      </h2>

      <div className="grid md:grid-cols-2 gap-12 items-start mb-16">
        <div className="rounded-2xl overflow-hidden">
          <img
            src="https://images.unsplash.com/photo-1618588487745-2d46620cabc5?w=800&h=600&fit=crop"
            alt="Stayfly Smokers store interior"
            className="w-full h-[400px] object-cover hover:scale-105 transition-transform duration-500"
          />
        </div>
        <div>
          <h3 className="text-2xl font-bold text-white mb-4">Your Local Smoke &amp; Vape Specialists</h3>
          <p className="text-gray-400 leading-relaxed mb-4">
            Stayfly Smokers is your premier smoke and vape shop located in Westgate Shopping Centre, Roodepoort. We pride ourselves on offering a comprehensive selection of quality products for adult customers.
          </p>
          <p className="text-gray-400 leading-relaxed mb-4">
            Whether you're looking for the latest vaping devices, traditional smoking accessories, or cannabis-related products, our friendly and knowledgeable team is here to help you find exactly what you need.
          </p>
          <p className="text-gray-400 leading-relaxed">
            We create a welcoming environment where customers can explore products, ask questions, and receive expert guidance. Visit us today and experience the Stayfly difference.
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {features.map((feature, index) => {
          const IconComponent = iconMap[feature.icon];
          return (
            <div
              key={index}
              className="bg-[#111] border border-[#222] rounded-2xl p-6 text-center hover:border-[#c8ff00]/30 transition-all duration-300 group"
            >
              <div className="w-14 h-14 mx-auto mb-4 rounded-full border-2 border-[#c8ff00]/30 flex items-center justify-center group-hover:border-[#c8ff00] transition-colors duration-300">
                <IconComponent size={24} className="text-[#c8ff00]" />
              </div>
              <h4 className="text-white font-semibold mb-2">{feature.title}</h4>
              <p className="text-gray-400 text-sm">{feature.description}</p>
            </div>
          );
        })}
      </div>
    </div>
  </section>
);

export default AboutSection;
